import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _AddSquareLightBig(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M9 1.5h6c1.9 0 3.274 0 4.322.142 1.034.139 1.675.406 2.153.883.477.478.744 1.119.883 2.153C22.5 5.726 22.5 7.1 22.5 9v6c0 1.9 0 3.274-.142 4.322-.139 1.034-.406 1.675-.883 2.153-.478.477-1.119.744-2.153.883-1.048.141-2.422.142-4.322.142H9c-1.9 0-3.274 0-4.322-.142-1.034-.139-1.675-.406-2.153-.883-.477-.478-.744-1.119-.883-2.153C1.5 18.274 1.5 16.9 1.5 15V9c0-1.9 0-3.274.142-4.322.139-1.034.406-1.675.883-2.153.478-.477 1.119-.744 2.153-.883C5.726 1.5 7.1 1.5 9 1.5Z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", d: "M12 7v10M17 12H7" })));
}
const AddSquareLightBig = forwardRef(_AddSquareLightBig);
export { AddSquareLightBig };
